import { Box, Typography } from '@mui/material';
import React from 'react';
import { COLORS } from '../../constants/colors';
import { Title } from '../Typography/Title';
import BogIcon from '../../assets/icons/BogIcon';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';
import TBCIcon from '../../assets/icons/TBCIcon';
import AppleIcon from '@mui/icons-material/Apple';


export const ChipComponent = (props) => {
    const { selected, language, onClick, title, id = "", logo, item } = props

    const { width } = useWindowDimensions()
    const uid = item?.uid || ""
    const isApplePay = uid === "apple_pay_bog"
    const isGooglePay = uid === "google_pay_bog"

    const RenderPaymentIcon = () => {
        if (isApplePay) {
            return <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, minWidth: 92, justifyContent: 'center' }}>
                <AppleIcon sx={{ fontSize: 22, color: 'black' }} />
                <Typography sx={{ color: 'black', fontFamily: 'Arial, Roboto, sans-serif', fontWeight: 600, fontSize: 17, lineHeight: 1 }}>
                    Pay
                </Typography>
            </Box>
        }
        if (isGooglePay) {
            return <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 104, justifyContent: 'center' }}>
                <Box component="span" sx={{ display: 'inline-flex', fontFamily: 'Arial, Roboto, sans-serif', fontWeight: 700, fontSize: 19, lineHeight: 1 }}>
                    <Box component="span" sx={{ color: '#4285f4' }}>G</Box>
                </Box>
                <Typography sx={{ color: '#3c4043', fontFamily: 'Arial, Roboto, sans-serif', fontWeight: 500, fontSize: 17, lineHeight: 1 }}>
                    Pay
                </Typography>
            </Box>
        }
        if (uid.indexOf("bog") > -1) {
            return <BogIcon />
        }
        if (uid.indexOf("tbc") > -1) {
            return <TBCIcon />
        }
        return <></>
    }

    const stylesWithLogo = {
        "&:hover": {

            backgroundColor: COLORS.BG_BEIGE,
            borderColor: `black`,
            color: 'black'
        },
        backgroundColor: selected ? COLORS.BG_BEIGE : 'white',
        display: 'flex',
        padding: '0 14px',
        alignItems: 'center',
        justifyContent: 'center',
        width: width < 600 ? "100%" : 220,
        minHeight: 52,
        borderRadius: 8,
        margin: 1,
        border: '1px solid #777',
        cursor: 'pointer'

    }

    return <Box sx={logo ?
        stylesWithLogo :
        {
            "&:hover": {

                backgroundColor: COLORS.BG_BEIGE,
                borderColor: `black`,
                color: 'black'
            },
            backgroundColor: selected ? COLORS.BG_BEIGE : 'white',
            display: 'flex',
            padding: 1,
            alignItems: 'center',
            justifyContent: 'space-around',
            minWidth: 120,
            maxHeight: 50,
            borderRadius: 10,
            margin: 1,
            border: '1px solid #777',
            cursor: 'pointer'
        }}
        onClick={onClick}
    >
        {logo ?
            <Box sx={{ display: 'flex', justifyContent: isApplePay || isGooglePay ? 'center' : 'flex-start', alignItems: 'center', width: '100%', gap: 1.25 }}>
                <RenderPaymentIcon />
                {!isApplePay && !isGooglePay && <Typography sx={{ width: '100%', color: item?.uid === "by_parts_bog" ? 'rgb(108,18,209)' : 'black', fontFamily: language === 'geo' ? 'FiraGo' : 'Roboto', fontWeight: '500', fontSize: 14, margin: '0 auto', lineHeight: 1.25, overflowWrap: 'anywhere' }}>
                        {title}
                    </Typography>}
            </Box>
            :
            <Title
                uppercase={true}
                fontFamily={language === 'geo' ? 'FiraGo' : 'Roboto'}
                color={'#333'}
                fontSize={13}
                style={{ cursor: 'pointer' }}
                fontWeight={'500'}
                text={title} />
        }
        {id.indexOf("bog") > -1 &&
            <img
                src={"https://api.voulez-vous.ge/assets/bog.png"} style={{
                    borderRadius: 3,
                    marginLeft: 5,
                    width: 30, height: 30
                }} />}
    </Box>
}
